import { isNil } from 'lodash';
import { clearTokensAction } from '@bbkAdminRedux/rtkq/auth-persisted-actions';
import { type Maybe } from '@bbkAdminUtils/utility-types';
import { LocalStorage } from '@bbkShared/LocalStorage';

const BrightBackLS = new LocalStorage('BrightBackAdminLS');

const getLS = <T = unknown>(key: string) =>
  BrightBackLS.get(key)[1] as Maybe<T>;

const setLS = (key: string, value: unknown) => {
  if (isNil(value)) {
    return BrightBackLS.del(key);
  }
  return BrightBackLS.put(key, value);
};

const BrightbackSession = {
  isTest: () => getLS<`${boolean}`>('isTest') === 'true',
  // Remove the obsolete keys without migrating them. The active context now
  // comes from the URL and Redux; this compatibility cleanup can be deleted
  // after clients have had a release cycle to run it.
  clearLegacyActiveContext: () => {
    sessionStorage.removeItem('activeCompanyKey');
    sessionStorage.removeItem('activeAppKey');
    window.localStorage.removeItem(BrightBackLS.getFullKey('activeCompanyKey'));
    window.localStorage.removeItem(BrightBackLS.getFullKey('activeAppKey'));
  },
  setAuthAlert: (alert: string | null) => setLS('authAlert', alert),
  getAuthAlert: () => getLS<string>('authAlert'),
  // The interactive session credential lives only in the backend-owned HttpOnly
  // cookie and is intentionally not readable here. `clear()` drops the local
  // non-secret metadata; ending the server session is done via the backend
  // `/api/v1/auth/session/logout` endpoint (see `brightbackAuthSlice.signOut`).
  clear: () => {
    window.bbkStore.dispatch(clearTokensAction());
  },
};

export default BrightbackSession;
